<template>
  <div class="elive-pagecon" v-loading="dataLoading">
    <div class="elive-wrap">
      <div class="ticket-box">
        <h2 class="page-tit fcdeep">{{ data.title_cn }}</h2>

        <div class="subtit">
          <div class="left">
            <span><el-icon><Clock /></el-icon> {{setFormatTime(data.date_start_cn, data.date_end_cn, "Y年M月D日 h:m")}}</span>
            <span><el-icon><Location /></el-icon> {{data.location_cn}}</span>
            <p class="p fcdeep" style="font-size: 16px;margin-top: 10px;"><el-icon><WarningFilled /></el-icon> 
              <!-- 官方正价票{{data.price_cn}}元，{{setOneTime(data.date_end_cn,"Y年M月D日")}}前购票 可享0元购票特权。 -->
              官方正价票599元<span v-if="id == 49 || id == 48">，5月17-21日限时特惠 99元</span>。
              <span v-if="id == 89">请注意本场会议将审核报名者身份，审核通过后工作人员将与您取得联系，则视为报名成功，否则无效。</span>
            </p>
          </div>
          <div class="right">
            <el-button type="primary" size="large" @click="goBack">
                返回列表</el-button
              >
          </div>
        </div>

        <el-divider />

        <el-row :gutter="20" class="forum-detail">
          <el-col :sm="8" class="mb-hide">
            <div class="imgbox">
              <img :src="data.image ? data.image : defaultImg" :alt="data.title_cn">
            </div>
          </el-col>
          <el-col :sm="16">
            <div class="ticket-detail">

              <p class="p" :style="type == 1 ? 'margin-bottom: 0;' : ''">
                <span class="name">购票类型： </span>
                <el-radio-group v-model="type" @change="changeType">
                  <el-radio :label="2">购票</el-radio>
                  <el-radio :label="1">赠票</el-radio>
                </el-radio-group>
              </p>
              <p class="p" v-show="type == 1">
                <span class="name"></span>
                <span class="fcdeep">成功购买“赠票”后，可选择赠送他人使用！</span>
              </p>
        
              <div class="p"><span class="name">数量：</span>
                <el-input-number v-model="ticket_num" :min="1" :max="type == 2 ? 1 : Infinity"/>
              </div>
        
              <p class="p"><span class="name">票价： </span><span class="fcdeep">￥{{buy_price}}</span></p>
              <div class="p">
                  <span class="name">优惠码： </span>
                  <div class="promotion">
                      <div class="promotion-con" id="promotionCon">
                          <div class="row" v-for="(item, index) in couponList" :key="index">
                            <el-space :size="10" wrap>
                              <el-input v-model="item.input" placeholder="请输入优惠码" :clearable="!item.is_comfirm" :disabled="item.is_comfirm"/>
                              <el-button type="primary" @click="confirmConversion(index)" v-show="!item.is_comfirm">确认优惠码</el-button>
                            </el-space>
                          </div>
                      </div>
                      <el-button type="warning" @click="addCoupon" :disabled="couponList.length >= ticket_num">新增优惠券</el-button>
                  </div>
              </div>

              <div class="p amount-p"><span class="name">应付总额：</span><span class="fcdeep amount">￥{{amount_payable}}</span></div>
              <el-button type="primary" size="large" class="paybtn" @click="creatOrder" :loading="loading">立即购票</el-button>
            </div>
          </el-col>
        </el-row>

        <el-divider />

        <div class="forum-intro">
          <p class="tit">活动简介</p>
          
          <div class="imgbox mb-show">
            <img :src="data.image ? data.image : defaultImg" :alt="data.title_cn">
          </div>

          <div class="info" v-html="data.content_cn"></div>

          <a :href="`https://www.sialchina.cn/events/${data.link_cn}`" target="_blank" class="btn">查看更多 + </a>
        </div>
      </div>
    </div>

    <Payment :ticket_id="ticket_id" :is_payment="is_payment"  @closePay="closePay" @successPay="successPay"></Payment>

    <!-- 关闭注册 -->
    <closeReg :dialogVisible="!$store.state.reg_info.prereg_status" :showClose="true" :redirectUrl="'/eventlive'"></closeReg>
    
  </div>
</template>

<script>
import { ElMessageBox } from "element-plus";
import showMsg from "@/utils/message";
import { reactive, toRefs, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { getEvent, createEventTicket, checkEventCoupon } from "@/api/eventlive";

import { formatTime, rangeFormatTime } from "@/utils/common";

import Payment from "@/components/OnsiteForumsPay/Payment.vue";
import closeReg from "@/components/CloseReg/closeVst.vue"

export default {
  components: {
    Payment,
    closeReg
  },
  setup() {
    const state = reactive({
        defaultImg: require("@/assets/images/default.jpg"),
        dataLoading: false,
        id: 0, //当前活动id
        data: {},
        ticket_num: 1, //票数
        type: 2,//购票类型
        loading: false,
        couponList: [ // 优惠券
          {
            input: "",
            is_comfirm: false,
            money: 0
          }
        ],
        buy_price: 0,//单价
        total_price: 0,//总金额
        totol_coupon: 0,//优惠金额
        amount_payable: 0,//应付金额

        ticket_id: 0, // 当前购票订单id
        is_payment: false, // 是否立即支付
        link_id: 0,
    });
    const route = useRoute();
    const router = useRouter();
    state.id = route.params.id;
    if(route.query) {
      state.link_id = route.query.link_id;
    }
    

    
    // 获取数据
    getEvent({id: state.id}).then((res)=>{
      const {data} = res;
      state.data = data;
      state.buy_price = Number(data.buy_price).toFixed(2);
      state.total_price = Number(data.buy_price).toFixed(2);
      state.amount_payable = Number(data.buy_price).toFixed(2);
      state.dataLoading = false;

    }).catch((err)=>{
      state.dataLoading = false;
      err.msg && ElMessageBox.alert(err.msg).then(()=>{
        router.push("/onsite/forums") ;
      }).catch(()=>{
        router.push("/onsite/forums") ;
      })
    })

    
    
    // 日期格式 
    const setOneTime = (date, formate)=>{
      const timestamp = new Date(date)/1000;
      return formatTime(timestamp, formate);
    }

    // 日期格式
    const setFormatTime = (start_time, end_time, format)=>{
      if(!start_time && !end_time) {
        return "";
      }
      var start = new Date(start_time)/1000;
      var end = new Date(end_time)/1000;
      if(!start_time || !end_time) {
        return formatTime(start || end, format)
      }
      return rangeFormatTime(start, end, format)
    }

    // 更改购买类型
    const changeType = (val)=>{
      if(val == 2) {
        state.ticket_num = 1;
        state.couponList = [
          {
            input: "",
            is_comfirm: false,
            money: 0
          }
        ]
      }
    }

    // 监听票数变化
    watch(()=>state.ticket_num,()=>{
      calculateAmount();
    })

    // 确认兑换
    const confirmConversion = (index)=>{
      if(state.couponList.length > state.ticket_num) {
        showMsg.error("优惠码不能超过购票数量");
        return;
      }

      const coupon_num = state.couponList[index].input;
      if(!coupon_num) {
        showMsg.error("请先输入优惠码");
        return;
      }
      checkEventCoupon({coupon_num}).then((res)=>{
        showMsg.success("优惠码有效");

        const {data} = res;
        state.couponList[index].money = data.money;
        state.couponList[index].is_comfirm = true;
        calculateAmount();
      }).catch((err)=>{
        showMsg.error(err.msg)
      })
    }

    // 计算金额
    function calculateAmount(){
      var totol_coupon = 0;
      var len = Math.min(state.ticket_num, state.couponList.length);
      for(var i = 0; i < len; i++) {
        totol_coupon += parseInt(state.couponList[i].money);
      }
      state.totol_coupon = totol_coupon.toFixed(2);
      state.total_price = (state.buy_price * state.ticket_num).toFixed(2);
      const amount_payable = (state.buy_price * state.ticket_num - state.totol_coupon).toFixed(2);
      state.amount_payable = amount_payable < 0 ? 0 : amount_payable;
    }

    // 新增优惠券
    const addCoupon = ()=>{
      if(state.couponList.length >= state.ticket_num) {
        return;
      }
      state.couponList.push({
        coupon_nums: "",
        money: 0,
        is_comfirm: false,
      })
    }

    // 创建订单
    const store= useStore();
    const creatOrder = ()=>{
      state.loading = true;
      const coupon_nums = [];
      state.couponList.map(o=>{
        if(o.is_comfirm) {
          coupon_nums.push(o.input);
        }
      })
      const postData = {
        type: state.type,
        num: state.ticket_num,
        event_id: state.id,
        coupon_nums: coupon_nums.join(","),
        link_id: state.link_id
      }
      // console.log("postData",postData);
      createEventTicket(postData).then(async(res)=>{
        state.loading = false;
        const { data } = res;
        // 更新角色
        await store.dispatch("user/changeRoles");

        if(data.is_pay == 1) {
          showMsg.success("支付成功", {}, ()=>{
            window.location.href="/onsite/orders";
          })
        }else {
          showMsg.success("购票成功，请支付");
          state.ticket_id = data.ticket_id;
          state.is_payment = true;
        }
      }).catch((err)=>{
        state.loading = false;
        showMsg.error(err.msg);
      })
    }

    // 关闭支付弹窗
    const closePay = ()=>{
      state.is_payment = false;
      state.ticket_id = 0;
      router.go(-1);
    }

    // 支付成功
    const successPay = ()=>{
      state.is_payment = false;
      state.ticket_id = 0;
      if(state.type == 2) {
        router.push("/onsite/orders");
      }else {
        router.push("/onsite/freeticket");
      }
    }

    const goBack = ()=>{
      router.go(-1);
    }

    return {
      ...toRefs(state),
      setOneTime,
      setFormatTime,
      changeType,
      confirmConversion,
      addCoupon,
      creatOrder,
      closePay,
      successPay,
      goBack,
    };
  },
};
</script>

<style lang="less" scoped></style>
